/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Settings_InvalidInputs */

const en_error_allocation_settings_invalid = /** @type {(inputs: Error_Allocation_Settings_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The allocation setup is not valid.`)
};

/**
* | output |
* | --- |
* | "The allocation setup is not valid." |
*
* @param {Error_Allocation_Settings_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_settings_invalid = /** @type {((inputs?: Error_Allocation_Settings_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Settings_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_settings_invalid(inputs)
});